import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const TutorsReadSlice = createSlice({
  name: "TutorsReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    tutorsRead: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successTutorsRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureTutorsRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearTutorsRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  tutorsRead,
  successTutorsRead,
  failureTutorsRead,
  clearTutorsRead,
} = TutorsReadSlice.actions;

export default TutorsReadSlice.reducer;
